import { LAPTOP_MEDIA_QUERY } from '../../common/components/utils/constants';

const SELECTORS = {
	banner: '#smart-banner',
	closeButton: '.smart-banner__action--close',
	getButton: '.smart-banner__action--get',
	siteHeader: '#header',
};

const CLASSES = {
	active: 'active',
};

const APP_URL = {
	iOS: 'https://apps.apple.com/us/app/bookdialysis-travel-app/id6473727929',
	Android: 'https://play.google.com/store/apps/details?id=com.bookdialysis.android&pli=1',
};

const LS_KEY = 'bookdialysis-smart-banner-dismissed';

export class SmartBanner {
	constructor() {
		this.mediaQuery = window.matchMedia(LAPTOP_MEDIA_QUERY);
		if (!this.isMobile()) return;

		this.elements = {
			banner: document.querySelector(SELECTORS.banner),
			closeButton: document.querySelector(SELECTORS.closeButton),
			getButton: document.querySelector(SELECTORS.getButton),
			siteHeader: document.querySelector(SELECTORS.siteHeader),
		};

		const requiredElements = [
			this.elements.banner,
			this.elements.closeButton,
			this.elements.getButton,
		];

		if (requiredElements.some((ele) => !ele)) {
			throw new Error('SmartBanner not initialized');
		}

		this.setupEventListeners();
		this.bindEvents();

		this.setup();
	}

	static init() {
		// eslint-disable-next-line
		new SmartBanner();
	}

	static getOS() {
		if (/android/i.test(navigator.userAgent)) return 'Android';
		if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) return 'iOS';
		return 'unknown';
	}

	static isSafari() {
		return /(?:(?!CriOS|FxiOS)Version)/.test(navigator.userAgent);
	}

	setup() {
		if (['Android', 'unknown'].includes(SmartBanner.getOS())) {
			this.elements.getButton.setAttribute('href', APP_URL.Android);
		} else if (SmartBanner.getOS() === 'iOS') {
			// Since iOS Safari has native support via meta tag, we can ignore this case
			if (SmartBanner.isSafari()) {
				this.toggleBanner();
				return;
			}

			this.elements.getButton.setAttribute('href', APP_URL.iOS);
		}

		this.toggleBanner(true, false);
	}

	toggleBanner(visible = false, dismissed = true) {
		const alreadyDismissed = localStorage.getItem(LS_KEY);

		if (visible && alreadyDismissed) return;

		if (visible) {
			this.elements.banner.classList.add(CLASSES.active);
			this.elements.banner.setAttribute('aria-hidden', 'false');
			this.elements.siteHeader.style.position = 'sticky';
			document.body.style.paddingTop = `${this.elements.banner.scrollHeight}px`;
		} else {
			this.elements.banner.classList.remove(CLASSES.active);
			this.elements.banner.setAttribute('aria-hidden', 'true');
			this.elements.siteHeader.style.position = '';
			document.body.style.paddingTop = '';
		}

		if (dismissed) localStorage.setItem(LS_KEY, true);
	}

	/**
	 * Is mobile media query met.
	 * @return {boolean}
	 */
	isMobile() {
		return this.mediaQuery.matches;
	}

	setupEventListeners() {
		this.elements.closeButton.addEventListener('click', () => this.toggleBanner());
		this.elements.getButton.addEventListener('click', () => this.toggleBanner());
	}

	bindEvents() {
		this.setup.bind(this);
		this.toggleBanner.bind(this);
		this.isMobile.bind(this);
	}
}
